import { WidgetType } from "@codemirror/view";

import { selectNode } from "components/organisms/manuscript/editor/visual/utils/select-node";

export class ManuscriptWidget extends WidgetType {
    bindSelection(element, view, extents) {
        element.addEventListener("mouseup", (event) => {
            event.preventDefault();
            selectNode(view, extents);
        });

        return element;
    }

    ignoreEvent() {
        return false;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
